import React, { useState, useEffect } from "react";
import NavBar from "./Components/NavBar";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "./FirebaseConfig/firebase";
import "./CSS/parrillas.css";
import Box from "@mui/material/Box";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import ItemPanel from "./Components/ItemPanel";
//mostrar imagen mapa
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { addDoc, updateDoc } from "firebase/firestore";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
const MySwal = withReactContent(Swal);

function ParrillasCDA() {
  const navigate = useNavigate();
  //configurar useState
  const [parrillas, setparrillas] = useState([]);
  const [fecha, setFecha] = useState();
  const [fechaFormateada, setFechaFormateada] = useState();

  const [fechaString, setFechaString] = useState("");
  const [parrillasInactivos, setparrillasInacticvos] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [reservasPorMeses, setReservasPorMeses] = useState([]); // MOSTRAR BARRA DE CARGA
  const [mesActual, setMesActual] = useState(""); // MOSTRAR BARRA DE CARGA
  const [selectedDate, setSelectedDate] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [mesSeleccionado, setMesSeleccionado] = useState("");
  const [puedeReservar, setPuedeReservar] = useState(true);

  const [elementos, setElementos] = useState([
    {
      nombre: "ZONA 1",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona1",
    },
    {
      nombre: "ZONA 2",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona2",
    },
    {
      nombre: "ZONA 3",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona3",
    },
    {
      nombre: "ZONA 4",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona4",
    },
    {
      nombre: "ZONA 5",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona5",
    },
    {
      nombre: "ZONA 6",
      imagen: "parrillamenu",
      estado: "disponible",
      id: "zona6",
    },
    {
      nombre: "CAJA CHINA 1",
      imagen: "caja",
      estado: "disponible",
      id: "caja1",
    },
    {
      nombre: "CAJA CHINA 2",
      imagen: "caja",
      estado: "disponible",
      id: "caja2",
    },
  ]);

  //abrir mapa
  const [open, setOpen] = useState(false);

  //abrir dialog meses
  const [open2, setOpen2] = useState(false);

  const handleOpenDialog = () => {
    setOpen(true);
  };
  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleCloseDialog2 = () => {
    setOpen2(false);
    setearCantidadReservas();
  };

  const setMesesArray = (numero) => {
    setReservasPorMeses((prevState) => ({
      ...prevState,
      [mesSeleccionado]: numero,
    }));
  };
  const editarCantidad = async () => {
    const documentoRef = doc(db, "SETEARVALORES", "reservapormes");
    await updateDoc(documentoRef, reservasPorMeses);
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Se ha editado con exito",
      showConfirmButton: false,
      timer: 1500,
    });
    handleCloseDialog2();
  };
  //referenciar la DB
  const parrillasList = collection(db, "PARRILLAS");

  //Modificar cambio de fecha
  const handleChange = (newValue) => {
    const opcionesDeFormato = { day: "numeric", month: "long" };

    let fechaStringTemp = dayjs(newValue).format("YYYY-MM-DD");
    const fechaParseada = parseISO(fechaStringTemp);
    const fechaFormateada = format(fechaParseada, "d 'de' MMMM 'del' yyyy", {
      locale: es,
    });
    setFechaFormateada(dayjs(newValue).format("YYYY-MM-DD"));
    setFechaString(fechaFormateada);
    setFecha(newValue);
    //fechaActual.toLocaleDateString("es-ES", opcionesDeFormato)
    /*setFechaString(new Date(newValue + "T17:00:00Z").toLocaleDateString(
		"es-ES",
		opcionesDeFormato
	  ));*/
    //console.log(dayjs(newValue).format("YYYY-MM-DD"));
    getParrillasbyFecha(dayjs(newValue).format("YYYY-MM-DD"));
    localStorage.setItem("fechaParrilla", dayjs(newValue).format("YYYY-MM-DD"));
    setMesActual(obtenerNombreDelMes(dayjs(newValue).format("YYYY-MM-DD")));
    setMesSeleccionado(
      obtenerNombreDelMes(dayjs(newValue).format("YYYY-MM-DD"))
    );

    //verificarMaximoReservas()
  };
  function obtenerNombreDelMes(fechaString) {
    // Parsea la cadena en un objeto Date
    const partesFecha = fechaString.split("-");
    const fecha = new Date(
      `${partesFecha[1]}-${partesFecha[2]}-${partesFecha[0]}`
    );
    // Obtiene el nombre del mes en letras
    const opcionesDeFormato = { month: "long" };
    const nombreDelMes = fecha.toLocaleDateString("es-ES", opcionesDeFormato);

    return nombreDelMes;
  }
  //funcion para mostrar la lista de parrillas
  const getparrillas = async () => {
    const data = await getDocs(parrillasList);
    setparrillas(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  //funcion para reservar TODAS LAS ZONAS DE PARRILLA
  const reservarTODO = async () => {
    //console.log("Es editar reserva?" + editarReserva);

    MySwal.fire({
      title: `Reservar todas las zona de parrilla el dia  ${fechaString}`,
      html: "",
      icon: "question",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Reservar todo",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        elementos.map(async (elemento) => {
          const parrillas = collection(db, `PARRILLAS`);
          let idReserva = "";
          await addDoc(parrillas, {
            nombre: localStorage.getItem("nombreLocal"),
            apellidos: localStorage.getItem("apellidoLocal"),
            zona: elemento.id,
            fecha: fechaFormateada,
            fechaReserva: new Date()
              .toLocaleString("es-ES", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
              })
              .toString(),

            cip: localStorage.getItem("idLocal"),
            idRef: localStorage.getItem("idDocumento"),
            estado: "Pagar en el club",
          }).then(async (docRef) => {
            idReserva = docRef.id;
            const entradaUsuario = collection(
              db,
              `USUARIOS/${localStorage.getItem("idDocumento")}/RESERVAS`
            );

            await addDoc(entradaUsuario, {
              lugar: "ZONA DE PARRILLAS",
              zona: elemento.id,
              fecha: fechaFormateada,
              fechaReserva: new Date()
                .toLocaleString("es-ES", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })
                .toString(),
              idReserva: idReserva,
              estado: "Pagar en el club",
            });

            const invitadosParrillas = collection(
              db,
              `PARRILLAS/${docRef.id}/INVITADOS`
            );
          });
        });
        let timerInterval;
        Swal.fire({
          title: "Reservando...",
          html: "Quedan <b></b> segundos.",
          timer: 6000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            const b = Swal.getHtmlContainer().querySelector("b");
            timerInterval = setInterval(() => {
              b.textContent = Swal.getTimerLeft() / 1000;
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location.reload();
            Swal.fire(
              "RESERVADO",
              "Se realizó la reserva de todo el día correctamente",
              "success"
            );
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // const parrillas = collection(db, `PARRILLAS`);
      }
    });
  };
  //Setear numero de reservas por mes
  const setearReservas = () => {
    setOpen2(true);
    /*
    Swal.fire({
      icon: "info",
      title: `Cantidad de reservas por mes ( ${reservasPorMes}) `,
      input: "number",
      showCancelButton: true,
      confirmButtonText: "Modificar",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        return fetch(`//api.github.com/users/${login}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .catch((error) => {
            Swal.showValidationMessage(`INGRESE CANTIDAD`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const documentoRef = doc(db, "SETEARVALORES", "reservapormes");
        await updateDoc(documentoRef, {
          cantidad: result.value.login,
        });
        setearCantidadReservas();
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Se ha modificado la cantidad de reserva por mes a ${result.value.login}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });*/
  };
  //Funcion para obtener al lista de parrillas por fecha
  const getParrillasbyFecha = async (fechaFormateada) => {
    const parrillasFiltrados = query(
      parrillasList,
      where("fecha", "==", fechaFormateada)
    );
    const data = await getDocs(parrillasFiltrados);
    if (data.docs.length > 0) {
      setparrillas(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    }
    setElementos(
      elementos.map((elemento) => {
        if (elemento.estado == "no disponible") {
          return {
            ...elemento,
            estado: "disponible",
          };
        }
        return elemento;
      })
    );
  };
  const shouldDisableDate = (date) => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return date < yesterday;
  };

  const setearCantidadReservas = async () => {
    const documentoRef = doc(db, "SETEARVALORES", "reservapormes");
    const documentoSnap = await getDoc(documentoRef);
    const documentoData = documentoSnap.data();
    // Haz algo con los datos del documento
    setReservasPorMeses(documentoData);
  };

  // Funcion para limitar las reservas del usuario por mes
  const verificarMaximoReservas = async (itemID) => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      puedeReservar
        ? navigate("./" + itemID)
        : Swal.fire(
            "",
            "Alcanzaste el límite máximo de zonas de parrilla reservadas, intenta seleccionando otra fecha.",
            "error"
          );
    } else {
      if (localStorage.getItem("nombreLocal") == "CIP") {
        navigate("./" + itemID);
      } else {
        if (localStorage.getItem("nivelUsuario") == "admin") {
          navigate("./" + itemID);
        } else {
          navigate("../login");
        }
      }
    }
  };
  // Funcion para limitar las reservas del usuario por mes
  const obtenerMaximoReservas = async () => {
    const q = query(
      collection(
        db,
        `USUARIOS/${localStorage.getItem("idDocumento")}/RESERVAS`
      ),
      where("lugar", "==", "ZONA DE PARRILLAS")
    );

    const querySnapshot = await getDocs(q);
    const numeroDeMes = new Date(`2023-${mesSeleccionado}-01`).getMonth();
    // Construye la fecha de inicio con el primer día del mes seleccionado
    const fechaInicio = new Date(2023, numeroDeMes, 1);
    // Construye la fecha de fin con el último día del mes seleccionado
    const fechaFin = new Date(2023, numeroDeMes + 1, 0);
    const documentosArray = querySnapshot.docs.map((doc) => doc.data());
    //console.log("mes seleccionado + " + mesActual);
    // Filtra los objetos por fecha
    const objetosFiltrados = documentosArray.filter((objeto) => {
      // Convierte la fecha del objeto en un objeto Date
      const fechaObjeto = new Date(objeto.fecha);
      // Compara si la fecha del objeto está en el rango deseado
      return fechaObjeto >= fechaInicio && fechaObjeto <= fechaFin;
    });
    if (objetosFiltrados.length >= reservasPorMeses[mesActual]) {
      console.log(false);
      setPuedeReservar(false);
    } else {
      console.log(true);

      setPuedeReservar(true);
    }
    if (reservasPorMeses[mesActual] != undefined) {
      setDatosCargados(true);
    }
    verificarReservaPorDia(fechaFormateada);
  };

  const verificarReservaPorDia = async (fechaActual) => {
    console.log("LA FECHA ES " + fechaFormateada);

    if (fechaActual == undefined) {
      return;
    }
    const q = query(
      collection(
        db,
        `USUARIOS/${localStorage.getItem("idDocumento")}/RESERVAS`
      ),
      where("fecha", "==", fechaActual.toString())
    );

    const querySnapshot = await getDocs(q);

    const documentosArray = querySnapshot.docs.map((doc) => doc.data());
    console.log(documentosArray);

    if (documentosArray.length >= 1) {
      console.log(false);

      setPuedeReservar(false);
    } else {
      console.log(true);

      setPuedeReservar(true);
    }
  };

  // TODO REPORTES
  const descargarReporte = () => {
    if (
      elementos.filter((item) => item.estado === "no disponible").length == 0
    ) {
      Swal.fire("", "No hay reservas para este dia", "error");
    } else {
      navigate("../zonaparrillas/reporte");
    }
  };
  //cerrar parrillas
  const cerrar = () => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      navigate("../panelUser");
    } else {
      if (localStorage.getItem("nombreLocal") == "CIP") {
        navigate("../panelCDA");
      } else {
        if (localStorage.getItem("nivelUsuario") == "admin") {
          navigate("../panelAdmin");
        } else {
          navigate("../login");
        }
      }
    }
  };

  //uso de useEffect
  useEffect(() => {
    const fechaActual = new Date();
    //console.log("adad  " + localStorage.getItem("fechaParrilla"));

    setMesActual(obtenerNombreDelMes(localStorage.getItem("fechaParrilla")));
    setMesSeleccionado(
      obtenerNombreDelMes(localStorage.getItem("fechaParrilla"))
    );

    setFecha(localStorage.getItem("fechaParrilla"));
    setFechaFormateada(localStorage.getItem("fechaParrilla"));
    const opcionesDeFormato = { day: "numeric", month: "long" };
    //console.log("adad  " + fechaFormateada);
    setFechaString(fechaActual.toLocaleDateString("es-ES", opcionesDeFormato));
    getParrillasbyFecha(localStorage.getItem("fechaParrilla"));
    setearCantidadReservas();
  }, []);
  useEffect(() => {
    obtenerMaximoReservas();
  }, [mesActual]);
  useEffect(() => {
    obtenerMaximoReservas();
  }, [reservasPorMeses]);
  useEffect(() => {
    verificarReservaPorDia(fechaFormateada);
  }, [fechaFormateada]);

  useEffect(() => {
    if (parrillas.length > 0) {
      const listaDeIdsSet = new Set(parrillas.map((item) => item.zona));

      setElementos(
        elementos.map((elemento) => {
          if (listaDeIdsSet.has(elemento.id)) {
            return {
              ...elemento,
              estado: "no disponible",
            };
          }
          return elemento;
        })
      );
    }
  }, [parrillas]);

  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="parrillas">
      <NavBar
        titulo="Zona de Parrillas"
        imagen="cerrar"
        logoTitulo="zonaparrillas"
        cerrar={cerrar}
      ></NavBar>
      <div className="colegiados-usuarios-buscador">
        <div className="colegiados-grid-container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={3}>
                <DatePicker
                  value={fecha}
                  onChange={handleChange}
                  renderInput={(params) => <TextField {...params} />}
                  shouldDisableDate={
                    localStorage.getItem("nivelUsuario") == "ingeniero"
                      ? shouldDisableDate
                      : null
                  }
                />
              </Stack>
            </LocalizationProvider>
            <div
              className="fau-addUser"
              style={{
                paddingLeft: "24px",
              }}
            >
              <input
                type="submit"
                value="Ver Mapa"
                className="btn-agregar"
                onClick={() => {
                  handleOpenDialog();
                }}
              />
            </div>
          </div>
          {localStorage.getItem("nivelUsuario") != "ingeniero" ? (
            <div className="btnCDA">
              <div className="col-deleteAll">
                <input
                  type="submit"
                  value="Reservar Todo"
                  className="btn-borrartodo"
                  onClick={() => {
                    reservarTODO();
                  }}
                />
              </div>
              <div className="col-deleteAll">
                <input
                  type="submit"
                  value="Reporte"
                  className="descargar-reporte"
                  onClick={() => {
                    descargarReporte();
                  }}
                />
              </div>
              <div className="col-deleteAll">
                <input
                  type="submit"
                  value="Setear reservas por mes"
                  className="setear-reservas"
                  onClick={() => {
                    setearReservas();
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="evento-cabecera">
        <p style={{ marginTop: "50px", marginLeft: "70px" }}>
          ZONAS DISPONIBLE
        </p>
      </div>
      {elementos.filter((item) => item.estado === "disponible").length == 0 ? (
        <div>
          <p style={{ marginTop: "50px", textAlign: "center" }}>
            No hay zonas disponibles
          </p>
        </div>
      ) : null}

      <div className="parrillas-grid-container">
        {elementos
          .filter((item) => item.estado === "disponible")
          .map((item) => (
            <div
              className="panel-element"
              onClick={() => verificarMaximoReservas(item.id)}
            >
              <ItemPanel nombre={item.nombre} imagen={item.imagen} />
            </div>
          ))}
      </div>
      {localStorage.getItem("nivelUsuario") != "ingeniero" ? (
        <div style={{ margin: "0px" }}>
          {elementos.filter((item) => item.estado === "no disponible").length !=
          0 ? (
            <div className="evento-cabecera">
              <p style={{ marginTop: "50px", marginLeft: "70px" }}>
                ZONAS OCUPADAS
              </p>
            </div>
          ) : null}

          <div className="parrillas-grid-container">
            {elementos
              .filter((item) => item.estado === "no disponible")
              .map((item) => (
                <div
                  className="panel-element"
                  onClick={() => navigate("./" + item.id)}
                >
                  <ItemPanel nombre={item.nombre} imagen={item.imagen} />
                </div>
              ))}
          </div>
        </div>
      ) : null}

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          style: {
            width: "100%",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img
            src={require(`./img/mapa.jpeg`)}
            alt="Imagen"
            style={{ width: "100%", height: "auto", maxHeight: "100%" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open2}
        onClose={handleCloseDialog2}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          style: {
            width: "100%",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent>
          <div
            style={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl
              fullWidth
              style={{ marginTop: "20px", width: "300px" }}
            >
              <InputLabel
                id="uncontrolled-native"
                variant="standard"
                htmlFor="uncontrolled-native"
              >
                Mes
              </InputLabel>
              <NativeSelect
                value={mesSeleccionado}
                onChange={(e) => setMesSeleccionado(e.target.value)}
                inputProps={{
                  name: "age",
                  id: "uncontrolled-native",
                }}
              >
                <option value={"enero"}>Enero</option>
                <option value={"febrero"}>Febrero</option>
                <option value={"marzo"}>Marzo</option>
                <option value={"abril"}>Abril</option>
                <option value={"mayo"}>Mayo</option>
                <option value={"junio"}>Junio</option>
                <option value={"julio"}>Julio</option>
                <option value={"agosto"}>Agosto</option>
                <option value={"septiembre"}>Septiembre</option>
                <option value={"octubre"}>Octubre</option>
                <option value={"noviembre"}>Noviembre</option>
                <option value={"diciembre"}>Diciembre</option>
              </NativeSelect>
            </FormControl>

            <TextField
              style={{ marginTop: "20px", width: "300px" }}
              fullWidth
              id="standard-basic"
              label="Reservas por mes"
              variant="standard"
              value={reservasPorMeses[mesSeleccionado]}
              onChange={(e) => setMesesArray(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => editarCantidad()} color="primary">
            Editar
          </Button>
          <Button onClick={handleCloseDialog2} color="error">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ParrillasCDA;
